export default {
  CREATE_EXPECTED_TRANSACTIONALITY_REPOSITORY: Symbol.for('CREATE_EXPECTED_TRANSACTIONALITY_REPOSITORY'),
  CREATE_EXPECTED_TRANSACTIONALITY_COMMAND: Symbol.for('CREATE_EXPECTED_TRANSACTIONALITY_COMMAND'),
  CREATE_EXPECTED_TRASNACTIONALITY_SERVICE: Symbol.for('CREATE_EXPECTED_TRASNACTIONALITY_SERVICE'),
};
